import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { QrCode, FileDown, ImageDown } from "lucide-react";
import { toast } from "sonner";

export const QrRegistro = () => {
  const [sedes, setSedes] = useState([]);
  const [sede, setSede] = useState("todas");
  const [preview, setPreview] = useState("");

  useEffect(() => { api.get("/sedes").then(({ data }) => setSedes(data)).catch(() => {}); }, []);

  const cargar = async (ruta, descarga) => {
    try {
      const { data } = await api.get(ruta, {
        params: sede === "todas" ? {} : { sede_id: sede },
        responseType: "blob",
      });
      const url = URL.createObjectURL(data);
      if (descarga) {
        const a = document.createElement("a");
        a.href = url;
        a.download = descarga;
        a.click();
        setTimeout(() => URL.revokeObjectURL(url), 4000);
      } else {
        setPreview(url);
      }
    } catch {
      toast.error("No se pudo generar el código QR");
    }
  };

  useEffect(() => { cargar("/qr-registro/png"); /* eslint-disable-next-line */ }, [sede]);

  return (
    <Card className="rounded-2xl p-6 border-border shadow-sm" data-testid="card-qr-registro">
      <div className="flex items-center gap-2 mb-2">
        <QrCode className="h-5 w-5 text-primary" />
        <h3 className="font-display text-lg font-bold">QR para nuevas familias</h3>
      </div>
      <p className="text-sm text-muted-foreground">
        Imprime el cartel y cuélgalo en recepción: al escanearlo, las familias van directas al
        Family Hub para registrarse y suscribirse.
      </p>
      <div className="grid gap-2 mt-6 max-w-xs">
        <Label>Sede del cartel</Label>
        <Select value={sede} onValueChange={setSede}>
          <SelectTrigger data-testid="qr-sede-select"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="todas">Sin sede preseleccionada</SelectItem>
            {sedes.map((s) => <SelectItem key={s.id} value={s.id}>{s.nombre}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      {preview && (
        <img src={preview} alt="QR de registro" data-testid="qr-preview"
          className="h-44 w-44 mt-6 rounded-xl border border-border bg-white p-2" />
      )}
      <div className="flex flex-wrap gap-2 mt-6">
        <Button className="rounded-full font-semibold" data-testid="qr-pdf-btn"
          onClick={() => cargar("/qr-registro/pdf", "cartel-qr-bspark.pdf")}>
          <FileDown className="h-4 w-4 mr-2" /> Descargar cartel A4
        </Button>
        <Button variant="outline" className="rounded-full" data-testid="qr-png-btn"
          onClick={() => cargar("/qr-registro/png", "qr-bspark.png")}>
          <ImageDown className="h-4 w-4 mr-2" /> Descargar sólo el QR
        </Button>
      </div>
    </Card>
  );
};
